import { slugify } from "../../utils/slugify.js";
import type { Competition } from "../Competition.js";
import { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getApplicationPath(competition: Competition, locale: Locale): string {
	return getPathInLocale(locale, {
		[Locale.cs]: `/${slugify(competition.headline[Locale.cs])}`,
		[Locale.en]: `/${slugify(competition.headline[Locale.en])}`,
	});
}
